export const STORE_FIELDS = Object.freeze({
  CNPJ: 'cnpj',
  NAME: 'name',
  WEBSITE_URL: 'websiteUrl',
  MONTHLY_ORDERS: 'monthlyOrders',
  TIME_ZONE: 'timezone',
  EMAIL: 'email',
  COMPLEMENT: 'addrComplement',
  TELEPHONE: 'telephone',
  STREET: 'addrStreet',
  CITY: 'addrCity',
  NUMBER: 'addrNumber',
  ADDR_DISTRICT: 'addrDistrict',
  STATE: 'addrState',
  ZIP_CODE: 'addrZipCode',
  IMAGE_URL: 'imageUrl',
});
